import React from 'react'
import { CustomAlert, StyledSnackbar } from './style'

interface SnackbarProps {
  open: boolean
  message: string
  icon?: React.ReactNode
  severity?: string
  onClose: () => void
  duration?: number
  customStyles?: React.CSSProperties
}

export const GenericSnackbar: React.FC<SnackbarProps> = ({
  open,
  message,
  icon,
  severity,
  onClose,
  duration = 3000, // Default duration: 3 seconds
  customStyles,
}) => {
  return (
    <StyledSnackbar
      open={open}
      autoHideDuration={duration}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      severity={severity === 'error' ? 'error' : 'success'}
    >
      <CustomAlert
        sx={customStyles}
        icon={icon}
        severity={severity === 'error' ? 'error' : 'success'}
      >
        {message}
      </CustomAlert>
    </StyledSnackbar>
  )
}
